import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-lib-base',
  templateUrl: './lib-base.component.html',
  styleUrls: ['./lib-base.component.css']
})
export class LibBaseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
